import React, { PureComponent } from 'react'
import styled from 'styled-components'

import Text from '../../components/Text'
import Flex from '../../components/Flex'
import Wrapper from '../../components/Wrapper'

import svgGatsby from '../../assets/img/stack/gatsby.svg'
import svgGraphql from '../../assets/img/stack/graphql.svg'
import svgPython from '../../assets/img/stack/python.svg'
import svgJs from '../../assets/img/stack/javascript.svg'
import svgReact from '../../assets/img/stack/react.svg'
import svgRuby from '../../assets/img/stack/sketch.svg'

const Container = styled.div`
  background: ${props =>
    props.theme.name === 'dark'
      ? props.theme.colors.dark[0]
      : props.theme.colors.light[0]};
  padding: 2em 0;
  position: relative;
`

const Logo = styled.img.attrs(({ company }) => ({
  draggable: false,
  alt: company,
  title: company
}))`
  max-height: 3em;
  max-width: 7em;
`

export default class Services extends PureComponent {
  render() {
    return (
      <Container>
        <Wrapper wide>
          <Text
            color="contrast.2"
            fontSize={2}
            lineHeight={2}
            mb={3}
            mt={2}
            textAlign="center"
          >
            We use some of the most effective modern programming tools
          </Text>
          <Flex flexWrap="wrap" justifyContent="center">
            <Flex
              alignItems="center"
              justifyContent="center"
              my={3}
              width={[1, 1 / 2, 1/3, 1/3, 1/6, 1/6]}
            >
              <Logo src={svgGatsby} company="Gatsby" />
            </Flex>
            <Flex
              alignItems="center"
              justifyContent="center"
              my={3}
              width={[1, 1 / 2, 1/3, 1/3, 1/6, 1/6]}
            >
              <Logo src={svgReact} company="React" />
            </Flex>
            <Flex
              alignItems="center"
              justifyContent="center"
              // ml={['auto', 3, 'auto']}
              // mr={['auto', '10%', 'auto']}
              my={3}
              width={[1, 1 / 2, 1/3, 1/3, 1/6, 1/6]}
            >
              <Logo src={svgGraphql} company="GraphQL" />
            </Flex>
            <Flex
              alignItems="center"
              justifyContent="center"
              // ml={['auto', 3, 'auto']}
              // mr={['auto', '10%', 'auto']}
              my={3}
              width={[1, 1 / 2, 1/3, 1/3, 1/6, 1/6]}
            >
              <Logo src={svgPython} company="Python" />
            </Flex>
            <Flex
              alignItems="center"
              justifyContent="center"
              // ml={['auto', 3, 'auto']}
              // mr={['auto', '10%', 'auto']}
              my={3}
              width={[1, 1/2, 1/3, 1/3, 1/6, 1/6]}
            >
              <Logo src={svgRuby} company="Ruby" />
            </Flex>
            <Flex
              alignItems="center"
              justifyContent="center"
              my={3}
              width={[1, 1 / 2, 1/3, 1/3, 1/6, 1/6]}
            >
              <Logo src={svgJs} company="JavaScript" />
            </Flex>
          </Flex>
        </Wrapper>
      </Container>
    )
  }
}
